import axios from 'axios';

const baseUrl = process.env.REACT_APP_AWS_API_GATEWAY_URL

export const fetchOrders = (id_company, accessToken) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'process': 'order_reference_select',
            'action': 'SELECT_ORDERS',
            'variables': JSON.stringify({id_company})
        })
    })
};
export const fetchProducts = (accessToken, id) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'process': 'order_reference_products_select',
            'action': 'SELECT_BY_ID_ORDER_REFERENCE',
            'variables': JSON.stringify({id})
        })
    })
};
export const update = (data, accessToken) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'process': 'warehouse_register_alter',
            'action': 'UPDATE',
            'variables': JSON.stringify(data)
        })
    })
};
export const create = (data, accessToken) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'process': 'warehouse_register_alter',
            'action': 'INSERT',
            'variables': JSON.stringify(data)
        })
    })
};
export const fetchRegister = (id, accessToken) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'process': 'warehouse_register_select',
            'action': 'SELECT_BY_ID',
            'variables': JSON.stringify({id})
        })
    })
};